import { render, staticRenderFns } from "./SynergismAntimatterGalaxyRow.vue?vue&type=template&id=efab61e4&scoped=true&"
import script from "./SynergismAntimatterGalaxyRow.vue?vue&type=script&lang=js&"
export * from "./SynergismAntimatterGalaxyRow.vue?vue&type=script&lang=js&"
import style0 from "./SynergismAntimatterGalaxyRow.vue?vue&type=style&index=0&id=efab61e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efab61e4",
  null
  
)

export default component.exports